import {
  getG11nAndTranslationsFromServer,
  TCustomGetServerSideProps,
} from '@crehana/next';

import { CREHANA_LEGAL_PAGE_KEY } from '../constants';
import locales from '../i18n';
import { TAppProps } from '../types';

export const getServerSideProps: TCustomGetServerSideProps<TAppProps> = async ({
  req,
}) => {
  const g11nData = await getG11nAndTranslationsFromServer({
    headers: req.headers,
    pageKey: CREHANA_LEGAL_PAGE_KEY,
    defaultTranslations: locales,
  });

  return {
    props: {
      ...g11nData,
      // NOTE: The crehana legal page doesn't need an organization slug but the
      // type expects it.
      organizationSlug: '',
    },
  };
};

export default getServerSideProps;
